import React, { useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import {
  startJWTRefreshChecker,
  stopJWTRefreshChecker,
} from './helpers';
import * as actions from './actions';

const authPropTypes = {
  component: PropTypes.any,
  path: PropTypes.any,
  loggedIn: PropTypes.any,
  exact: PropTypes.bool,
};

const Auth: React.FC<PropTypes.InferProps<typeof authPropTypes>> = ({
  component: Component,
  path,
  loggedIn,
  exact,
}) => {
  const location = useLocation();
  const { referrer } = queryString.parse(location.search);
  const redirectPath = referrer?.toString() || '/';
  return (
    <Route
      exact={!!exact}
      path={path}
      render={props =>
        !loggedIn ? <Component {...props} /> : <Redirect to={redirectPath} />
      }
    />
  );
};

Auth.propTypes = authPropTypes;

const protectedPropTypes = {
  component: PropTypes.any,
  path: PropTypes.any,
  loggedIn: PropTypes.any,
  logoutUser: PropTypes.func,
  refreshSession: PropTypes.func,
  loginUser: PropTypes.func,
  exact: PropTypes.bool,
};

const Protected: React.FC<PropTypes.InferProps<typeof protectedPropTypes>> = ({
  component: Component,
  path,
  loggedIn,
  logoutUser,
  refreshSession,
  exact,
}) => {
  const location = useLocation();
  let loginPath: string = '';
  if (!loggedIn) {
    loginPath = '/login';
    if (path !== '/') {    loginPath += `?${queryString.stringify({
            referrer: location.pathname + location.search,
          })}`;
    }
  }
  useEffect(() => {
    if (loggedIn) {
      startJWTRefreshChecker({ loggedIn, logoutUser, refreshSession });
      return stopJWTRefreshChecker;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  return (
    <Route
      exact={!!exact}
      path={path}
      render={props =>
        loggedIn ? <Component {...props} /> : <Redirect to={loginPath} />
      }
    />
  );
};

Protected.propTypes = protectedPropTypes;

// Access the Redux state to check if the user is logged in
const mapStateToProps = state => ({
  loggedIn: get(state, 'session.loggedIn'),
});

const mapDispatchToProps = dispatch => ({
  logoutUser: () => dispatch(actions.logoutUser()),
  refreshSession: (token, user) =>
    dispatch(actions.updateSessionWithNewJWT(token, user)),
});

// Connect Auth to the redux state
export const AuthRoute = connect(mapStateToProps, null)(Auth);

// Connect Protected to the redux state
export const ProtectedRoute = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Protected);
